document.addEventListener('DOMContentLoaded', function() {
    const anchorNavContainers = document.querySelectorAll('.anchor_navigation');
    const productNavElements = document.querySelectorAll('[id^="product_nav_"]');
    
    // Clear and rebuild navs
    anchorNavContainers.forEach(container => container.innerHTML = '');
  
    productNavElements.forEach(function(element) {
      const elementId = element.id; 
      let defaultName = elementId.replace('product_nav_', '')
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      const name = element.getAttribute('name') || defaultName;
  
      anchorNavContainers.forEach(container => {
        const anchorLink = document.createElement('a');
        anchorLink.href = '#' + elementId;
        anchorLink.textContent = name;
        anchorLink.classList.add('nav-link');
  
        anchorLink.addEventListener('click', function(e) {
          e.preventDefault();
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        });
  
        container.appendChild(anchorLink);
      });
    });
  
    // ----- Highlight active section -----
    const links = document.querySelectorAll('.anchor_navigation .nav-link');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const id = entry.target.getAttribute('id');
        if (entry.isIntersecting) {
          // remove all active states
          links.forEach(link => link.classList.remove('active'));
          // add active state to all navs that point to this section
          document.querySelectorAll(`.anchor_navigation .nav-link[href="#${id}"]`)
            .forEach(link => link.classList.add('active'));
        }
      });
    }, { threshold: 0.5 }); // adjust threshold if needed
  
    productNavElements.forEach(el => observer.observe(el));
  });
  